import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { addCollection } from "../../../../api/collections"
import * as Yup from "yup"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import FIELDS, { MASTER_FIELDS, MEDIA_FIELDS } from "./CONSTANT"
import CollectionForm from "./CollectionForm"
import { useParams } from "react-router-dom"
import moment from "moment"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null,
    'date': null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

function getValidationRules(type){
    return MEDIA_FIELDS.forEach(f => {
        initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
        if(f.type == 'file'){
            FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")
    
        }else{
            FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
        }
    })
}

const AddCollection = () => {
    const { t } = useTranslation()
    let navigate = useHistory()

    ///// get pool

    const {poolId} = useParams()

    const [poolData, setPoolData] = useState(null)
    const [shift, setShift] = useState(null)
    const [employees, setEmployees] = useState([])    

    //// 
    const { setData, loading, error, success } = useResponse(addCollection, () => {
        navigate.push("/pool-hours/"+poolId)
    })
    
    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues,
        validationSchema: Yup.object(getValidationRules()),
        onSubmit: data => {
            if(!employees.find(e => e.error)){
                function getDate(numOfDays){
                    const date = data.date_from
                    return moment(date).add(numOfDays, 'd').format("YYYY-MM-DD")
                }
                const FullData = {
                    ...data, 
                    shift_id: shift?.id,
                    pool_id: poolId,
                    hours: employees.map(e => ({
                        ...e, 
                        hourPrice : shift?.price,
                        periods: e.periods
                                    .map((p, i) => ({
                                        ...p, 
                                        from: new Date(getDate(i)+"T"+p.from+":00").toUTCString(), 
                                        to: new Date(getDate(i)+"T"+p.to+":00").toUTCString()
                                    }))
                                    .map(p => p.length > 0 ? p : {})
                    })),
                }
                setData({ data: FullData, type: "add" })
            }
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Collections")}
                        breadcrumbItem={t("Add Collection")}
                    />
                    
                    <Form
                        className="needs-validation"
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <div className="d-flex mb-2" style={{gap: "10px"}}>
                            <h5 style={{fontSize: "14px"}}>Contract: {poolData?.companyContract?.jobTitle} , </h5>
                            <h5 style={{fontSize: "14px"}}>Pool: {poolData?.name}</h5>
                        </div>
                        <CollectionForm 
                            poolId={poolId} 
                            employees={employees} 
                            setEmployees={setEmployees} 
                            setPoolData={setPoolData}
                            validation={validation} 
                            isEmployessLoaded={true}
                            shift={shift}
                            setShift={setShift}
                        />

                        <FormButtonHandler btnTxt="Add" loading={loading} />

                        <ResultHandler
                            error={error}
                            success={success}
                            successMsg={"Created Successfully!"}
                        />
                    </Form>
                               
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddCollection